import React, { useState } from 'react';
import {
  Container,
  Grid,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import Profile from './Profile';
import ProfileDetails from './ProfileDetails';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const Account = () => {
  const classes = useStyles();
  const [showdetails, setShowdetails] = useState(false);

  return (
    <Page
      className={classes.root}
      title="Account"
    >
      <Container maxWidth="lg">
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            lg={4}
            md={6}
            xs={12}
          >
            <Profile onClick={()=> setShowdetails(!showdetails)}/>
          </Grid>
          <Grid
            item
            lg={8}
            md={6}
            xs={12}
          >
            {showdetails && <ProfileDetails />}
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

export default Account;
